function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e6e6e;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -3)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M26.945,3H5.055A3.058,3.058,0,0,0,2,6.055V20.945A3.058,3.058,0,0,0,5.055,24H13v3H11a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2H19V24h7.945A3.058,3.058,0,0,0,30,20.945V6.055A3.058,3.058,0,0,0,26.945,3ZM17,27H15V24h2Zm11-6.055A1.056,1.056,0,0,1,26.945,22H5.055A1.056,1.056,0,0,1,4,20.945V6.055A1.056,1.056,0,0,1,5.055,5H26.945A1.056,1.056,0,0,1,28,6.055Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M7,16h4a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M16,18H7a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M21.5,7V9A2.5,2.5,0,1,1,19,11.5H17A4.5,4.5,0,1,0,21.5,7Z"
}));

function SvgRedemptionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionsIcon);
export default __webpack_public_path__ + "static/media/redemptions-icon.f3440d80.svg";
export { ForwardRef as ReactComponent };